import { render, staticRenderFns } from "./Exam-detail.vue?vue&type=template&id=432986aa&"
import script from "./Exam-detail.vue?vue&type=script&lang=js&"
export * from "./Exam-detail.vue?vue&type=script&lang=js&"
import style0 from "./Exam-detail.vue?vue&type=style&index=0&id=432986aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports